import { Routes } from '@angular/router';
import {NgxPermissionsGuard } from 'ngx-permissions';
import { AddstreammpgComponent } from './addstreammpg/addstreammpg.component';
import { ViewstreammpgComponent } from './viewstreammpg/viewstreammpg.component';
import { PosttopicComponent } from './posttopic/posttopic.component';
import { SavetopicComponent } from './savetopic/savetopic.component';
import { FreedownloadComponent } from './freedownload/freedownload.component';
import { AddfreedownloadComponent } from './addfreedownload/addfreedownload.component';
import { AdminForumComponent } from './admin-forum/admin-forum.component';
import { AdminblogComponent } from './adminblog/adminblog.component';
import { VgroupComponent } from './vgroup/vgroup.component';
import { GroupdetailsComponent } from './groupdetails/groupdetails.component';
import { VguserComponent } from './vguser/vguser.component';

export const DiscussionRoutes: Routes = [
    {
    path: '',
    children: [
      {
        path: 'addstreammpg',
        component: AddstreammpgComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Discussion',
          urls: [{title: 'Stream Mapping',url: '/discussion/addstreammpg'},{title: 'Add Stream Mapping'}],
          permissions: 
          {
            only: ['29','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      },
      {
        path: 'editstreammpg',
        component: AddstreammpgComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Discussion',
          urls: [{title: 'Stream Mapping',url: '/discussion/addstreammpg'},{title: 'Edit Stream Mapping'}],
          permissions: 
          {
            only: ['30','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      }
       ,
      {
        path: 'viewstreammpg',
        component: ViewstreammpgComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Discussion',
          urls: [{title: 'Stream Mapping',url: '/discussion/viewstreammpg'},{title: 'View Stream Mapping'}],
          permissions: 
          {
            only: ['32','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      }   ,
      {
        path: 'topic',
        component: PosttopicComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Discussion',
          urls: [{title: 'Topic',url: '/discussion/topic'},{title: 'View Topic'}],
          permissions: 
          {
            only: ['97','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      },
      {
        path: 'addtopic',
        component: SavetopicComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Discussion',
          urls: [{title: 'Topic',url: '/discussion/topic/addtopic'},{title: 'Add Topic'}],
          permissions: 
          {
            only: ['94','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      }
      ,
      {
        path: 'edittopic/:id',
        component: SavetopicComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Discussion',
          urls: [{title: 'Topic',url: '/discussion/topic/addtopic'},{title: 'Edit Topic'}],
          permissions: 
          {
            only: ['95','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      },
      {
        path: 'forum',
        component: AdminForumComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Forum',
          urls: [{title: 'Forum',url: '/discussion/forum'},{title: 'View Forum'}],
          permissions: 
          {
            only: ['98','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      }
      ,
      {
        path: 'blog',
        component: AdminblogComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Blog',
          urls: [{title: 'Blog',url: '/discussion/blog'},{title: 'View Blog'}],
          permissions: 
          {
            only: ['102','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      }
      ,
      {
        path: 'freedownload',
        component: FreedownloadComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Discussion',
          urls: [{title: 'Free download',url: '/discussion/freedownload'},{title: 'View Download'}],
          permissions: 
          {
            only: ['109','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      },
      {
        path: 'editdownload/:id',
        component: AddfreedownloadComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Discussion',
          urls: [{title: 'Free download',url: '/discussion/addfreedownload'},{title: 'Edit Download'}],
          permissions: 
          {
            only: ['107','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      },
      {
        path: 'vgroup',
        component: VgroupComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Group',
          urls: [{title: 'Group',url: '/discussion/vgroup'},{title: 'View Group'}],
          permissions: 
          {
            only: ['113','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      },
      {
        path: 'group/:id',
        component: GroupdetailsComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Group',
          urls: [{title: 'Group',url: '/admin/discussion/vgroup/'},{title: 'Group Details'}],
          permissions: 
          {
            only: ['113','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      },

      {
        path: 'vgroup/:id',
        component: VguserComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Group',
          urls: [{title: 'Group',url: 'admin/discussion/vguser'},{title: 'View Group User'}],
          permissions: 
          {
            only: ['113','XXX'],
            redirectTo: '/admin/dashboard'
          }
        }
      },
    ]
    }
]


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/discussion.routing.ts